export enum EntityCommitStatus {
  PENDING = 'PENDING',
  ERROR = 'ERROR',
  DONE = 'DONE'
}
